import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "inicio",
      component: () =>
        import(/* webpackChunkName: "inicio" */ "./views/web/inicio.vue"),
    },

    /* //////////// ADMIN ///////////// */
    {
      path: "/admin/login/",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/admin/login.vue"),
    },
    {
      path: "/admin",
      name: "admin",
      component: () =>
        import(/* webpackChunkName: "admin" */ "./views/admin/index.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/ventas",
      name: "ventas_admin",
      component: () =>
        import(/* webpackChunkName: "ventas_admin" */ "./views/admin/ventas.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/ventas-no-stock",
      name: "ventas_no_stock_admin",
      component: () =>
        import(/* webpackChunkName: "ventas_no_stock_admin" */ "./views/admin/ventas_no_stock.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/print/ventas",
      name: "ventas_print_admin",
      component: () =>
        import(/* webpackChunkName: "ventas_print_admin" */ "./views/admin/print/ventas.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/print/productos",
      name: "productos_print_admin",
      component: () =>
        import(/* webpackChunkName: "productos_print_admin" */ "./views/admin/print/productos.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/print/venta/:id",
      name: "venta_print_admin",
      component: () =>
        import(/* webpackChunkName: "venta_print_admin" */ "./views/admin/print/venta.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/print/gastos",
      name: "gastos_print_admin",
      component: () =>
        import(/* webpackChunkName: "gastos_print_admin" */ "./views/admin/print/gastos.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/ventas/agregar",
      name: "agregar_venta_admin",
      component: () =>
        import(/* webpackChunkName: "agregar_venta_admin" */ "./views/admin/agregar_venta.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/ventas/editar/:id",
      name: "editar_venta_admin",
      component: () =>
        import(/* webpackChunkName: "editar" */ "./views/admin/editar_venta.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/venta/:id",
      name: "venta_admin",
      component: () =>
        import(/* webpackChunkName: "venta_admin" */ "./views/admin/venta.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/categorias",
      name: "categorias_admin",
      component: () =>
        import(/* webpackChunkName: "categorias_admin" */ "./views/admin/categorias.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/agregar-categoria",
      name: "agregar_categoria_admin",
      component: () =>
        import(/* webpackChunkName: "agregar_categoria_admin" */ "./views/admin/agregar_categoria.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/categoria/:id/editar",
      name: "categoria_editar_admin",
      component: () =>
        import(/* webpackChunkName: "categoria_editar_admin" */ "./views/admin/editar_categoria.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/gastos",
      name: "gastos_admin",
      component: () =>
        import(/* webpackChunkName: "gastos_admin" */ "./views/admin/gastos.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/agregar-gasto",
      name: "agregar_gasto_admin",
      component: () =>
        import(/* webpackChunkName: "agregar_gasto_admin" */ "./views/admin/agregar_gasto.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/gasto/:id/editar",
      name: "editar_gasto_admin",
      component: () =>
        import(/* webpackChunkName: "editar_gasto_admin" */ "./views/admin/editar_gasto.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/productos",
      name: "productos_admin",
      component: () =>
        import(/* webpackChunkName: "productos_admin" */ "./views/admin/productos.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/agregar-producto",
      name: "agregar_producto_admin",
      component: () =>
        import(/* webpackChunkName: "agregar_producto_admin" */ "./views/admin/agregar_producto.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/producto/:id/editar",
      name: "producto_editar_admin",
      component: () =>
        import(/* webpackChunkName: "producto_editar_admin" */ "./views/admin/editar_producto.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/admin/producto/:id/galeria",
      name: "producto_galeria_admin",
      component: () =>
        import(/* webpackChunkName: "producto_galeria_admin" */ "./views/admin/galeria_producto.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/admin/mensajes",
      name: "mensajes_admin",
      component: () =>
        import(/* webpackChunkName: "mensajes_admin" */ "./views/admin/mensajes.vue"),
      meta: { requiresAuth: true },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const rutaProtegida = to.matched.some((record) => record.meta.requiresAuth);
  const rutaNoProtegida = to.matched.some(
    (record) => record.meta.noRequiresAuth
  );
  const user = localStorage.getItem("id");

  /*
   * No dejamos ingresar al usuario no logueado a las rutas protegidas
   */
  if (rutaProtegida === true && user === null) {
    next({ name: "login" });
  } else {
    next();
  }

  /*
   * No dejamos ingresar al usuario logueado
   * A las rutas que no requieren de autenticación
   */
  if (rutaNoProtegida === true && user != null) {
    next({ name: "admin" });
  } else {
    next();
  }
});

export default router;
